import { GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import React from "react";

const CompanyRepresentativeFormFields = () => {
  return (
    <GridContainer spacing={4} mt={0}>
      <GridItem>
        <InputFormField fieldName={"representativeCapacity"} labelCode={"l.representativeCapacity"} required={false} />
      </GridItem>
      <GridItem>
        <InputFormField required={true} fieldName={"representedCompany"} labelCode={"l.eik"} />
      </GridItem>
    </GridContainer>
  );
};
export default CompanyRepresentativeFormFields;
